import { ECountry } from 'App/i18n/i18n.types';

export const OTHER_REASON_MIN_LENGTH = 4;

export const ZIPCODE_MASK = '99999-999';
export const ARG_ZIPCODE_MASK = '9999';
export const MX_ZIPCODE_MASK = '99999';
export const CPF_MASK = '999.999.999-999';
export const CNPJ_MASK = '**.***.***/****-99';
export const NFE_MASK =
  '9999 9999 9999 9999 9999 9999 9999 9999 9999 9999 9999';
export const BR_PHONE_MASK = '(99) 99999-9999';
export const HEIGHT_MASK = '999';
export const DEPTH_MASK = '999';
export const WIDTH_MASK = '999';
export const WEIGHT_MASK = '99999';

export const DEFAULT_CURRENCY_MASK = '9999999999'; // 10 -> max 999.999,99
export const ARG_CURRENCY_MASK = '999999999999'; // 12 -> max 9.999.999,99

export const ARG_DNI_MIN_LENGTH = 7;
export const ARG_DNI_MAX_LENGTH = 8;
export const ARG_CUIT_LENGTH = 11;
export const SIMPLE_PHONE_MASK = '999999999999999';

export const PHONE_MASK_MAP = {
  [ECountry.BRAZIL]: BR_PHONE_MASK,
  [ECountry.ARGENTINA]: SIMPLE_PHONE_MASK,
  [ECountry.MEXICO]: SIMPLE_PHONE_MASK
};

export const CURRENCY_MASK_MAP = {
  [ECountry.BRAZIL]: DEFAULT_CURRENCY_MASK,
  [ECountry.ARGENTINA]: ARG_CURRENCY_MASK,
  [ECountry.MEXICO]: DEFAULT_CURRENCY_MASK
};

export const DCE_KEY_LENGTH = 44;
export const DCE_KEY_VISUAL_MAX_LENGTH = 54;
